import React from 'react';

const Gallery = ({ color = 'currentColor', size = 35 }: { color?: string, size?: number }) => {
  return <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <rect x="276.5" y="348" fill={color} width="188.5" height="189.1"/>
    <rect x="527.8" y="350" fill={color} width="188.5" height="189.1"/>
    <rect x="276.5" y="593.9" fill={color} width="188.5" height="189.1"/>
    <rect x="527.8" y="599.9" fill={color} width="188.5" height="189.1"/>
    <path fill={color} d="M641.8,252.5c13.1-2.1,26.2-3.8,39.3-6.2c59.5-11,105.6-59.8,113.9-119.9c1.5-11.1,3.2-22.1,6.3-33.3
	c1.4,8.8,3.2,17.5,4.2,26.3c3.3,28.8,13.1,54.9,31.7,77.3c24.2,29.1,55.2,46.3,92.9,51.3c10.2,1.4,20.3,3.1,30.7,6.1
	c-7.9,1.3-15.8,2.9-23.8,3.8c-33.8,3.6-63.8,16-88.3,39.8c-22.4,21.7-36.3,48.1-41.4,79c-1.6,9.8-2.8,19.7-4.3,29.5
	c-0.4,2.5-1.4,5-2.4,8.5c-3.1-17.5-4.6-34.1-9-49.9c-16.2-58-54.7-92.7-113.5-104.8c-9.4-1.9-19-2.8-28.6-4.2
	c-2.5-0.4-5-1.1-7.6-1.7C641.8,253.5,641.8,253,641.8,252.5L641.8,252.5z"/>
  </svg>;
};

export default Gallery;
